import styled from 'styled-components';
import Button from '@carvana/showroom-forms/Button/Secondary';

export const StyledContainer = styled.div`
  max-width: 390px;
  margin-bottom: 40px;
`;

export const StyledButton = styled(Button)`
  width: 100%;
`;